import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTasks } from '../context/TaskContext';
import { useMCPTasks } from '../hooks/useMCPTasks';

const TaskSync = () => {
  const { user } = useAuth();
  const { loadTasks } = useTasks();
  const { tasks: firebaseTasks, loading, updateTrigger } = useMCPTasks();
  const lastSyncedTasksRef = useRef(null);

  // Sync Firebase tasks to TaskContext when they change
  useEffect(() => {
    if (user && firebaseTasks && !loading) {
      // Always sync when firebaseTasks changes, regardless of comparison
      loadTasks(firebaseTasks);
    } else {
    }
  }, [user, firebaseTasks, loading, updateTrigger]);

  // Debug: Log when firebaseTasks changes
  useEffect(() => {
  }, [firebaseTasks]);

  return null; // This component doesn't render anything
};

export default TaskSync;
